import { Button, Col, Input, Row, Select, Table } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  TICKET_ADDRESS,
  TICKET_NAME,
  TICKET_START_TIME,
  TICKET_STATUS,
  TICKET_STATUS_NAME,
} from 'src/services/api/constant'
import { apiApproveOrder, apiOrderHistories } from 'src/store/sagas/payment'
import { formatCurrency } from 'src/utils/helper'
import addNotification, { NOTIFICATION_TYPE } from 'src/utils/toast'

export const ListOrder = () => {
  const token = localStorage.getItem('access_token')
  const [page, setPage] = useState(1)
  const [totalItem, setTotalItem] = useState(0)
  const [data, setData] = useState([])
  const [objSearch, setObjSearch] = useState({
    orderInfo: null,
    status: null,
  })
  const [limit, setLimit] = useState(10)
  if (!token) {
    window.location.replace('/')
  }

  if (!token) {
    window.location.replace('/')
  }

  useEffect(() => fetchHistories(), [])

  const buildFilter = () => {
    return Object.keys(objSearch).map((key) => ({
      column: key,
      text: objSearch[key],
    })).filter(v => v.text !== null && v.text !== undefined)
  }

  const fetchHistories = async (pageSelect, limitSelect) => {
    const query = {
      page: pageSelect || page,
      limit: limitSelect || limit,
      filter: JSON.stringify(buildFilter()),
    }
    const response = await apiOrderHistories(query)
    if (response.statusCode === 200) {
      const dataTable = response.data.items
      setData(dataTable)
      setTotalItem(response.data.meta.total)
    } else {
      addNotification(
        response.message,
        NOTIFICATION_TYPE.ERROR,
        'Có lỗi xảy ra!',
      )
    }
  }

  const columns = [
    {
      title: 'Tên Sự kiện',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => TICKET_NAME[record.eventCode],
    },
    {
      title: 'Ngày diễn ra',
      dataIndex: 'startTime',
      key: 'startTime',
      render: (_, record) => TICKET_START_TIME[record.eventCode],
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
      render: (_, record) => TICKET_ADDRESS[record.eventCode],
    },
    {
      title: 'Thành tiền',
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record) => formatCurrency(record?.amount || 0),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (_, record) => record?.email,
    },
    {
      title: 'Mã đơn',
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => record.orderInfo,
    },
    {
      title: 'Số ghế',
      dataIndex: 'seat',
      key: 'seat',
      render: (_, record) => record.seat.map((item) => item).join(', '),
    },
    {
      title: 'Thời gian đặt',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) =>
        record ? moment(record?.createdAt).format('HH:mm:ss DD/MM/YYYY') : null,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => TICKET_STATUS_NAME[record.status],
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <>
          {record.status == TICKET_STATUS.CREATED && (
            <div className="flex">
              <Button
                type="primary"
                className="mr-1"
                onClick={onApproveOrder(record.id, record.eventCode)}
              >
                Xác nhận
              </Button>
              <Button
                danger
                onClick={onRejectOrder(record.id, record.eventCode)}
              >
                Từ chối
              </Button>
            </div>
          )}
        </>
      ),
    },
  ]

  const handleChangePage = (page, pageSize) => {
    fetchHistories(page, pageSize)
    setPage(page)
    setLimit(pageSize)
  }

  const handleSearchStatus = (val) => {
    setObjSearch({
      ...objSearch,
      status: val,
    })
  }

  const handleSearchOrderInfo = (val) => {
    setObjSearch({
      ...objSearch,
      orderInfo: val,
    })
  }

  const onSubmitSearch = () => {
    fetchHistories()
  }

  const onApproveOrder = (orderId, eventCode) => async () => {
    const body = {
      orderId: [orderId],
      eventCode: eventCode,
    }
    const res = await apiApproveOrder(body)
    if (res.statusCode === 200) {
      addNotification(
        res.message,
        NOTIFICATION_TYPE.SUCCESS,
        'Approve Thành công!',
      )
      // fetchHistories()
    } else {
      addNotification(res.message, NOTIFICATION_TYPE.ERROR, 'Có lỗi xảy ra!')
    }
    updateStatusOrderLocal(orderId, TICKET_STATUS.APPROVED)
  }

  const onRejectOrder = (orderId, eventCode) => async () => {
    const body = {
      orderId: [orderId],
      eventCode: eventCode,
    }
    const res = await apiApproveOrder(body)
    if (res.statusCode === 200) {
      addNotification(
        res.message,
        NOTIFICATION_TYPE.SUCCESS,
        'Reject Thành công!',
      )
      fetchHistories()
    } else {
      addNotification(res.message, NOTIFICATION_TYPE.ERROR, 'Có lỗi xảy ra!')
    }
    updateStatusOrderLocal(orderId, TICKET_STATUS.REJECTED)
  }

  const updateStatusOrderLocal = (orderId, status) => {
    const newData = data.map((item) => {
      if (item.orderInfo === orderId) {
        return { ...item, status: status }
      }
      return item
    })
    setData(newData)
  }

  return (
    <>
      <Row gutter={24} className="mt-2 pl-12 pr-12">
        <div className="bg-[#fff] pt-2 w-full">
          <Col span={24}>
            <h1 className="text-2xl text-black mb-2">Danh sách Đơn đặt vé</h1>
          </Col>
          <Col span={24} className="flex mb-4">
            <Col span={8} className="!pl-0">
              <Input
                style={{ color: '#000 !important' }}
                className="!text-black"
                type="text"
                placeholder="Search Order Info"
                onChange={handleSearchOrderInfo}
              />
            </Col>
            <Col span={8}>
              <Select
                onChange={handleSearchStatus}
                allowClear
                style={{ color: '#000', width: '100%' }}
                placeholder="Trạng thái"
                options={Object.values(TICKET_STATUS).map((status) => ({
                  label: TICKET_STATUS_NAME[status],
                  value: `${status}`,
                }))}
              />
            </Col>
            <Col span={8}>
              <Button onClick={onSubmitSearch} type="primary">
                Tìm kiếm
              </Button>
            </Col>
          </Col>
          <Table
            scroll={{ x: 500 }}
            className="w-full text-black"
            columns={columns}
            dataSource={data || []}
            pagination={{
              current: page, // Trang hiện tại
              pageSize: limit, // Số hàng trên mỗi trang
              total: totalItem || 0, // Tổng số hàng
              onChange: (page, pageSize) => handleChangePage(page, pageSize),
              showSizeChanger: true, // Hiển thị tùy chọn thay đổi số hàng trên mỗi trang
              pageSizeOptions: ['10', '20', '50'],
            }}
          />
        </div>
      </Row>
    </>
  )
}
